import React, { Component } from "react";
import styles from "./Profile.module.css";
import PreLoader from "../../components/PreLoader/PreLoader";

function Profile() {
  return (
    <>
      <div className={`${styles.profilePageCont}`}>
        <div className={`${styles.profilePage}`}>
          <PreLoader> در حال حاضر این بخش در دسترس نیست</PreLoader>
        </div>
      </div>
    </>
  );
}

export default Profile;
